import InstancesTypes from './InstancesTypes';

export default InstancesTypes;
